import Appsignal from '@appsignal/javascript';

export const appsignal = new Appsignal({
    namespace: 'web',
    key: import.meta.env.VITE_APPSIGNAL_PUSH_API_KEY,
});
